"use strict";
angular.module("planCommandMonitorOncePublicOpinionAddEditModule", [])
    .controller('planCommandMonitorOncePublicOpinionAddEditCtrl', ['$scope', 'trsHttpService', '$q', '$validation', 'modalDialog','$state', 'paramsId','$modalInstance',
        function($scope, trsHttpService, $q, $validation, modalDialog,$state,paramsId,$modalInstance) {
            initStatus();
            initData();
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {               
                //数据来源下拉菜单数组
                $scope.datasource = [{ "name": "全部来源", "value": "1" },
                    { "name": "按来源类型", "value": "2" },
                    { "name": "按来源栏目", "value": "3" }
                ];
                //选中的数据来源类型
                $scope.defaultSelected = $scope.datasource[0];
                $scope.page = {
                    "CURRPAGE": 1,
                    "PAGESIZE": 20,
                    "ITEMCOUNT": 0,
                    "PAGECOUNT": 1
                };
                //存放完整来源类型数据的数组
                $scope.sourcelist = [];
                //按来源栏目时存放已选栏目的数组
                $scope.selectedItem = [];
                //去除“最近选择”的来源类型数组
                $scope.sourcetypearray = [];
                //按来源类型是存放已选来源类型的数组
                $scope.selectedsourcetypearray = [];
                //当前选择的来源类型对象
                $scope.ischecked = $scope.sourcelist[0];
                // $scope.sourceType = $scope.defaultSelected.value;
                // 加工和解析请求参数的临时数组
                $scope.sourceContent = [];
                $scope.status = {
                    "copyCurrPage": 1,
                    searchKW: ""
                };

            };
            /**
             * [initData description:初始化数据]
             */
            function initData() {
                initType().then(function(data) {
                    $scope.sourcelist = data;
                    $scope.sourcetypearray = data.slice(0, data.length - 1);
                    editing();
                });
            };
            /**
             * [editing description] 点击编辑进入页面后调用的初始化函数
             * @return {[type]} [description]
             */
            function editing() {
                var recSourceType = [];
                if (paramsId.id!="") {
                    $scope.title = "编辑";
                    var params = {
                        modalname: "pubSentimentMgr",
                        method: "getpubsentimentbyid",
                        methodname: "queryDataFromBigScreen",
                        serviceid: "mlf_bigdatascreen",
                        id: paramsId.id
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                        var toDoEdit = data.mapResult.content;
                        $scope.monitorName = toDoEdit.monitorName||"";
                        $scope.searchIncludeAll = toDoEdit.searchIncludeAll||"";
                        $scope.searchIncludeAnyone = toDoEdit.searchIncludeAnyone||"";
                        $scope.searchIncludeNone = toDoEdit.searchIncludeNone||"";
                        jQuery.each($scope.datasource, function(index, val) {
                            if (val.value == toDoEdit.sourceType) {
                                $scope.defaultSelected = $scope.datasource[index];
                                return;
                            }
                        });
                        if (toDoEdit.sourceType == 2) {
                            recSourceType = toDoEdit.sourceContent.split(',');
                            for (var i = 0; i < recSourceType.length; i++) {
                                jQuery.each($scope.sourcetypearray, function(index, val) {
                                    if (val.SOURCENAME == recSourceType[i]) {
                                        $scope.selectedsourcetypearray.push(val);
                                    };
                                });
                            };
                            recSourceType.splice(0, recSourceType.length);
                        } else if (toDoEdit.sourceType == 3) {
                            $scope.firstData($scope.defaultSelected);
                            recSourceType = toDoEdit.sourceContent.split("$");
                            for (var i = 0; i < recSourceType.length; i++) {
                                let column = {
                                    sourceName: "",
                                    channel: "",
                                    section: "",
                                    isproduct: "",
                                    hybaseid:""
                                };
                                $scope.sourceContent = recSourceType[i].split(",");
                                column.sourceName = $scope.sourceContent[0];
                                column.channel = $scope.sourceContent[1];
                                column.section = $scope.sourceContent[2];
                                column.isproduct = $scope.sourceContent[3];
                                column.hybaseid=$scope.sourceContent[4];
                                $scope.selectedItem.push(column);
                                $scope.sourceContent.splice(0, $scope.sourceContent.length);
                            };
                        };
                    });
                } else {
                    $scope.title = "添加";
                    $scope.monitorName = "";
                    $scope.searchIncludeAll = "";
                    $scope.searchIncludeAnyone = "";
                    $scope.searchIncludeNone = "";
                };
            };

            /**
             * [initType description]初始化类型
             */
            function initType() {
                var deffer = $q.defer();
                var params = {
                    typeid: "screen",
                    serviceid: "consensus",
                    modelid: "getsourcename"
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            };
            /**
             * [tab description]  来源栏目列表页签切换函数
             * @param  {[type]} temp [来源栏目列表value] 
             * @param  {[type]} temp[来源名称]
             * @return {[type]} []
             */
            $scope.tab = function(temp) {
                $scope.status.searchKW = '';
                $scope.ischecked = temp;
                $scope.page.CURRPAGE = 1;
                req();
            };
            /**
             * [tab_search description] 通过关键字检索栏目名称 
             * @return {[type]} []
             */
            $scope.tab_search = function() {
                var params = {
                    modalname: "pubSentimentMgr",
                    method: "getsearchresult",
                    methodname: "queryDataFromBigScreen",
                    serviceid: "mlf_bigdatascreen",
                    page_no: $scope.page.CURRPAGE - 1,
                    page_size: $scope.page.PAGESIZE,
                    sourcename: $scope.ischecked.SOURCENAME,
                    searchword: $scope.status.searchKW
                };
                if (params.searchword === '') {
                    delete params.searchword;
                    params.method = 'getsourcechannel';
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.list = data.pageItems || data.content;
                    $scope.page.ITEMCOUNT = data.totalItemCount || data.totalElements;
                    $scope.page.PAGECOUNT = data.totalPageCount || data.totalPages;
                    itemDistinguish($scope.list, params);
                });
            };
            /**
             * [req description]  请求来源栏目列表
             * @param  {[type]} temp []0             * @param  {[type]} temp[]
             * @return {[type]} []
             */
            function req() {
                var params = {
                    modalname: "pubSentimentMgr",
                    method: "getsourcechannel",
                    methodname: "queryDataFromBigScreen",
                    serviceid: "mlf_bigdatascreen",
                    page_no: $scope.page.CURRPAGE - 1,
                    page_size: $scope.page.PAGESIZE,
                    sourcename: $scope.ischecked.SOURCENAME,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.page.ITEMCOUNT = data.totalItemCount||data.totalElements;
                    $scope.page.PAGECOUNT = data.totalPageCount||data.totalPages;
                    $scope.list = data.pageItems||data.content;
                    if(angular.isDefined($scope.list)){
                        itemDistinguish($scope.list, params);
                    };                   
                });
            };
            /**
             * [itemDistinguish description] 栏目列表中相同sourceName的栏目区分显示
             * @param  [array] num [来源栏目对应数据] 
             * @return {[type]} []
             */
            function itemDistinguish(array, params) {
                //array[r].sourceName1=array[r].sourceName;
                if (params.sourcename == "wz" || params.sourcename == "app") {
                    for (var r = 0; r < array.length; r++) {
                        array[r].sourceName = array[r].sourceName + "(" + array[r].channel + ")";
                    }
                } else if (params.sourcename == "jtcpk") {
                    for (var r = 0; r < array.length; r++) {
                        if (array[r].section == 'app' || array[r].section == 'website') {
                            array[r].sourceName = array[r].sourceName + " " + array[r].channel + "(" + array[r].sectionname + ")";
                        } else if (array[r].section == 'weixin' || array[r].section == 'szb') {
                            array[r].sourceName = array[r].sourceName + " " + "(" + array[r].sectionname + ")";
                        }
                    }
                }
            };
            /**
             * [firstData description] 按来源栏目中获取首个新华社源栏目列表
             * @param  {[type]} num [按来源栏目对应数据] 
             * @return {[type]} []
             */
            $scope.firstData = function(num) {
                if (num.value == 3) {
                    $scope.tab($scope.sourcelist[0]);
                } else {
                    return;
                };
            };
            /**
             * [selectPageNum description] 单页面显示数据个数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                req();
            };
            /**
             * [jumpToPage description] 跳转到指定页面
             * @return {[type]} [description]
             */
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                req();
            };
            /**
             * [pageChanged description] 页面切换
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                if ($scope.status.searchKW != '') {
                    $scope.tab_search();
                } else {
                    req();
                }
            };
            /**
             * [addItem description]  已选栏目添加删除
             *  @param  {[type]} tpl [栏目数据] 
             * @return {[type]} [description]
             */
            $scope.addItem = function(tpl) {
                for (var i = 0; i < $scope.selectedItem.length; i++) {
                    if (tpl.sourceName == $scope.selectedItem[i].sourceName && tpl.channel == $scope.selectedItem[i].channel) {
                        $scope.selectedItem.splice(i, 1);
                        return;
                    };
                };
                $scope.selectedItem.push(tpl);
            };
            /**
             * [compare description] 判断来源栏目列表中栏目是否被选中
             * @return {[type]} [description]
             */
            $scope.compare = function(tpl) {
                for (var i = 0; i < $scope.selectedItem.length; i++) {
                    if (tpl.sourceName == $scope.selectedItem[i].sourceName && tpl.channel == $scope.selectedItem[i].channel) {
                        return true;
                    }
                };
                return false;
            };
            /**
             * [addItem description]  添加删除来源类型
             *  @param  {[type]} tpl [栏目数据] 
             * @return {[type]} [description]
             */
            $scope.addsourceType = function(tpl) {
                for (var i = 0; i < $scope.selectedsourcetypearray.length; i++) {
                    if (tpl.SOURCENAME == $scope.selectedsourcetypearray[i].SOURCENAME) {
                        $scope.selectedsourcetypearray.splice(i, 1);
                        return;
                    };
                };
                $scope.selectedsourcetypearray.push(tpl);
            };
            $scope.isChecked = function(tpl) {
                for (var i = 0; i < $scope.selectedsourcetypearray.length; i++) {
                    if (tpl.SOURCENAME == $scope.selectedsourcetypearray[i].SOURCENAME) {
                        return true;
                    }
                };
                return false;
            };
            /**
             * [addpubsentiment description]  增加/编辑舆情
             *  @param  {[type]}  [] 
             * @return {[type]} [description]
             */
            $scope.addpubsentiment = function() {
                $validation.validate($scope.add_edit)
                    .success(function() {
                        var str = "";
                        var params = {
                            modalname: "pubSentimentMgr",
                            method: "addpubsentiment",
                            methodname: "queryDataFromBigScreen",
                            serviceid: "mlf_bigdatascreen",
                            monitorname: $scope.monitorName,
                            searchincludeall: $scope.searchIncludeAll,
                            searchincludeanyone: $scope.searchIncludeAnyone,
                            searchincludenone: $scope.searchIncludeNone,
                            sourcetype: $scope.defaultSelected.value,
                            sourcecontent: "",
                            id: paramsId.id
                        };
                        var regRule = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
                        if(regRule.test(params.monitorname)){
                            modalDialog.alertType("保存失败", "标题不能包含特殊字符", "error", false);
                            return;
                        }
                        if (params.sourcetype == 1) {
                            params.sourcecontent = "";
                        } else if (params.sourcetype == 2) {
                            if ($scope.selectedsourcetypearray.length === 0) {
                                modalDialog.alertType("保存失败", "请选择来源类型", "error", false);
                                return;
                            } else {
                                jQuery.each($scope.selectedsourcetypearray, function(index, val) {
                                    $scope.sourceContent.push(val.SOURCENAME);
                                });
                                params.sourcecontent = $scope.sourceContent.join(",");
                                $scope.sourceContent.splice(0, $scope.sourceContent.length);
                            };
                        } else if (params.sourcetype == 3) {
                            if ($scope.selectedItem.length === 0) {
                                modalDialog.alertType("保存失败", "请选择来源栏目", "error", false);
                                return;
                            } else {
                                str = "";
                                jQuery.each($scope.selectedItem, function(index, val) {
                                    $scope.sourceContent.push(val.sourceName);
                                    $scope.sourceContent.push(val.channel);
                                    $scope.sourceContent.push(val.section);
                                    $scope.sourceContent.push(val.isproduct);
                                    $scope.sourceContent.push(val.hybaseid);
                                    str += $scope.sourceContent.join(",");
                                    str += "$";
                                    $scope.sourceContent.splice(0, $scope.sourceContent.length);
                                });
                                params.sourcecontent = str.slice(0, -1);
                            };
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                            if (data.mapResult.status == "SUCCESS") {
                                if (paramsId.id!="") {
                                    modalDialog.alertType('编辑成功', '', 'success', false, function() {$modalInstance.dismiss();});
                                } else {
                                    modalDialog.alertType("添加成功","","success",false, function() {$modalInstance.dismiss();});
                                }
                            };
                        });
                    })
                    .error(function(msg) {
                        modalDialog.alertType("提交失败", "请检查填写项", "error", false);
                    });
            };
            $scope.cancel = function() {
                  $modalInstance.dismiss();
            };
        }
    ]);